import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import Price from '../Price';

import './DetailPrice.module.css';

const DetailPrice = ({
  isRequired = false,
  price,
  storeId,
  optionData,
  qty,
  perItemType
}) => {
  const [t] = useTranslation();

  // Strike through prices in UK must be prefixed with "RRP"
  const isUKStore = storeId === 'gb_en';

  const specialPrice = get(optionData, 'attributes.specialPrice', null);
  const strikePrice = specialPrice ? get(optionData, 'price', null) : null;
  const displayPrice = strikePrice ? Number(specialPrice) : price;
  const savings = strikePrice ? strikePrice - displayPrice : null;

  return (
    <>
      <Price
        price={displayPrice * qty}
        additionalText={
          strikePrice && strikePrice !== displayPrice ? (
            <div styleName="strike">
              {isUKStore && 'RRP: '}
              <Price price={strikePrice * qty} showVatMessage={false} />
            </div>
          ) : null
        }
      />
      {isRequired && t('Included')}
      {qty > 1 && (
        <div styleName="per-item">
          <Price
            style={{ display: 'inline' }}
            price={price}
            showVatMessage={false}
          />
          {` ${perItemType ? perItemType : t('per item')}`}
        </div>
      )}

      {savings ? (
        <div styleName="savings">
          {t('Save')} <Price price={savings * qty} showVatMessage={false} />
        </div>
      ) : null}
    </>
  );
};

export default DetailPrice;
